import { render, staticRenderFns } from "./CommunicationAdd.vue?vue&type=template&id=1fe9c7d3&"
import script from "./CommunicationAdd.vue?vue&type=script&lang=ts&"
export * from "./CommunicationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe9c7d3')) {
      api.createRecord('1fe9c7d3', component.options)
    } else {
      api.reload('1fe9c7d3', component.options)
    }
    module.hot.accept("./CommunicationAdd.vue?vue&type=template&id=1fe9c7d3&", function () {
      api.rerender('1fe9c7d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/communications/CommunicationAdd.vue"
export default component.exports